var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { ThemeProvider } from "styled-components";
import { FlexBox } from '../../shared/Element';
import { doconTheme } from "../../../theme/default";
var handleColors = function (props) {
    var _a = props.theme.v2.colors, borderColor = _a.borderColor, text = _a.text;
    return "\n    border: solid 1px " + borderColor + ";\n    background: white;\n    color: " + text.subHeading + ";\n  ";
};
var Root = styled(FlexBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 8px;\n  padding: 18px;\n  ", ";\n"], ["\n  border-radius: 8px;\n  padding: 18px;\n  ", ";\n"])), function (props) { return handleColors(props); });
var DoconTile = function (props) {
    return (React.createElement(ThemeProvider, { theme: doconTheme },
        React.createElement(Root, __assign({}, props))));
};
export default styled(DoconTile)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2;
